import { HfsSettingsActionEnum } from 'fleet-data-model';
import { type Update } from '../../types';

export const mapWeatherTimerExecutionTargets = (update: Update) => [
  {
    hfsActionId: HfsSettingsActionEnum.AUTO_TIMER_ENABLED,
    iprId: update.assetId,
    payload: {
      enabled: update.enabled,
    },
  },
];
